import React from "react";

const Pagination = ({
  page,
  limit,
  total,
  onPageChange,
  label = "items"
}) => {
  const totalPages = Math.ceil(total / limit);
  if (totalPages <= 1) return null;

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  const getPages = () => {
    const pages = [];
    const maxVisible = 3;

    let startPage = Math.max(1, page - 1);
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className="card-footer d-flex flex-wrap justify-content-between align-items-center">
      <small className="text-muted">
        Showing {start}–{end} of {total.toLocaleString()} {label}
      </small>

      <nav>
        <ul className="pagination pagination-sm mb-0">
          {/* Previous */}
          <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(page - 1)}
              disabled={page === 1}
            >
              Previous
            </button>
          </li>

          {/* Page numbers */}
          {getPages().map((p) => (
            <li key={p} className={`page-item ${p === page ? "active" : ""}`}>
              <button
                className="page-link"
                onClick={() => onPageChange(p)}
              >
                {p}
              </button>
            </li>
          ))}

          {/* Next */}
          <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => onPageChange(page + 1)}
              disabled={page === totalPages}
            >
              Next
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
